

jQuery(function($) {
  if( $.cookie('code') && check_code_validity($.cookie('code')) ){
    if( $("#access_code").length ){
      $("#access_code").val( $.cookie('code') );
    }
    $(".popup-container").hide();
    body_scroll(true);
  } else{
    $(".popup-container").show();
    body_scroll(false);
  }
  

  $("#check-code-btn").click(function(){
    var entered_code = $("#code").val();
    if( check_code_validity(entered_code) ){
      $.cookie('code', entered_code, { expires: 2 });
      $(".popup-container").hide();
      body_scroll(true);
    } else{
      $(".popup-container .error").text('code is incorrect.');
    }
  });
  
  $("#terms_conditions").change(function(){
    $("#checkout-btn").attr('disabled', !$(this).is(":checked"));
  });
});


function check_code_validity(user_code){
  
  	
    var current_code = 'asdf';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '12320';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  	
    var current_code = '';
    if( current_code != '' && current_code == user_code ){
    	return true;
    }
  
  return false;
}

function body_scroll(flag){
	if(flag)
      $('body').css('overflow', 'auto');
  	else
      $('body').css('overflow', 'hidden');
}